import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import Home from './Pages/Home';
import Sobre from './Pages/Sobre';
import Servicos from './Pages/Servicos';
import Fotos from './Pages/Fotos';
import Contatos from './Pages/Contatos';
import Login from './components/Auth/Login';
import Cadastro from './components/Auth/Cadastro';
import LoginNovamente from './components/LoginNovamente';

import Painel from './Pages/Painel';
import Cliente from './Pages/Cliente';
import RotaProtegida from './components/RotaProtegida';

import SetaRolar from './components/SetaRolar';
import BotaoWhatsapp from './components/BotaoWhatsapp';
import Preloader from './components/Preloader';
import { AuthProvider } from "@/context/AuthContext";
import Agendamentos from './Pages/Agendamentos';
import FormularioCliente from './Pages/FormularioCliente';

function AppRoutes() {
  const location = useLocation();
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    if (location.pathname === '/') {
      setCarregando(true);
      const timer = setTimeout(() => setCarregando(false), 1500);
      return () => clearTimeout(timer);
    } else {
      setCarregando(false);
    }
  }, [location.pathname]);

  if (carregando) return <Preloader />;

  const esconderExtras = location.pathname === "/login";

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/sobre" element={<Sobre />} />
        <Route path="/servicos" element={<Servicos />} />
        <Route path="/fotos" element={<Fotos />} />
        <Route path="/contatos" element={<Contatos />} />
        <Route path="/login" element={<Login />} />
        <Route path="/cadastro" element={<Cadastro />} />
        <Route path="/loginNovamente" element={<LoginNovamente />} />
        <Route path="/formulario"element={<FormularioCliente />} />

        {/* Rotas protegidas */}
        <Route
          path="/painel"
          element={
            <RotaProtegida>
              <Painel />
            </RotaProtegida>
          }
        />
        <Route
          path="/cliente"
          element={
            <RotaProtegida>
              <Cliente />
            </RotaProtegida>
          }
        />
        <Route
          path="/agendamentos"
          element={
            <RotaProtegida>
              <Agendamentos />
            </RotaProtegida>
          }
        />
      </Routes>

      {!esconderExtras && (
        <>
          <SetaRolar />
          <BotaoWhatsapp />
        </>
      )}
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;
